import FlutterInstall from "../../../../contents/docs/integrate/_snippets/install-flutter.mdx";
import FlutterSendEvents from "../../../../contents/docs/integrate/send-events/_snippets/send-events-flutter.mdx";
import FeatureFlagsLibsIntro from "../../../../contents/docs/libraries/_snippets/feature-flags-libs-intro.mdx";
import FlutterFeatureFlagsCode from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-flutter.mdx";
import * as React from 'react';
export default {
  FlutterInstall,
  FlutterSendEvents,
  FeatureFlagsLibsIntro,
  FlutterFeatureFlagsCode,
  React
};